import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { PublicCustomDataOptions, useCompanyData } from '~/data/company';

import { EmployeeModuleTabPath_People } from '../../PeopleModule/data';
import { EmployeeModuleTabSetupProps } from '../../types';

export interface UseLimitedAccessPeopleTabsOutput {
  limitedAccessTabs: EmployeeModuleTabPath_People[];
  tabsPropsLimitedAccessTabs: EmployeeModuleTabSetupProps<EmployeeModuleTabPath_People>[];
}

export const useLimitedAccessPeopleTabs =
  (): UseLimitedAccessPeopleTabsOutput => {
    const { t } = useTranslation();
    const {
      companyData: {
        config: { fComPublicCustomdata, fComAbsCalendarShowAll },
      },
    } = useCompanyData();

    return useMemo(() => {
      const isCustomDataTabPublic = (
        customDataOption: PublicCustomDataOptions,
      ) => fComPublicCustomdata.includes(customDataOption);

      const tabsPropsLimitedAccessTabs: EmployeeModuleTabSetupProps<EmployeeModuleTabPath_People>[] =
        [
          {
            id: EmployeeModuleTabPath_People.Basic,
            title: t('laBasicData'),
          },
        ];

      // Conditionally accessible tabs
      if (isCustomDataTabPublic(PublicCustomDataOptions.EMPLOYEE)) {
        tabsPropsLimitedAccessTabs.push({
          id: EmployeeModuleTabPath_People.CustomData,
          title: t('laCustomData'),
        });
      }
      if (isCustomDataTabPublic(PublicCustomDataOptions.EMPLOYEE_POS)) {
        tabsPropsLimitedAccessTabs.push({
          id: EmployeeModuleTabPath_People.JobDescription,
          title: t('laPositionCustomData'),
        });
      }
      if (fComAbsCalendarShowAll) {
        tabsPropsLimitedAccessTabs.push({
          id: EmployeeModuleTabPath_People.Absences,
          title: t('laVacationsAndAbsences'),
        });
      }

      return {
        limitedAccessTabs: tabsPropsLimitedAccessTabs.map((tab) => tab.id),
        tabsPropsLimitedAccessTabs,
      };
    }, [t, fComPublicCustomdata, fComAbsCalendarShowAll]);
  };
